import { Link } from "react-router-dom";
import { Button, CardHeader, CardTitle } from "reactstrap";
import styled from "styled-components"





export const StyledButton = styled(Button).attrs(() => ({
    className: "btn-outline-danger btn-block",
}))``;

export const InvoiceIcon = styled.i.attrs(() => ({
    className: "icon-invoice-view",
}))`font-size: 50px;
color: #696969;`;


export const StyledCardTitle = styled(CardTitle)`color: #21C1E0;
font-family: "Baloo";`

export const PayInvoiceIcon = styled.i.attrs(() => ({
    className: "icon-pay-invoice",
}))`font-size: 50px;
color: #696969;`;


export const FeeIcon = styled.i.attrs(() => ({
    className: "icon-fee-certificate",
}))`font-size: 50px;
color: #696969;`;


export const RefundIcon = styled.i.attrs(() => ({
    className: "icon-refund",
}))`font-size: 50px;
color: #696969;`;

export const StyledGenerateButton = styled(Button).attrs(() => ({
    className: "btn-block btn-lg bg-header  hover:bg-header  border-0 text-base text-white ",
}))`color: "white";`;


export const StyledCardHeader = styled(CardHeader).attrs(() => ({
    className: "text-white bg-header",
}))`;
font-family: "baloo";
font-size: 1.3em;`;



export const StyledLink = styled.a.attrs(() => ({
    className: "btn-block btn-lg bg-purple border-0  fw-bold",
}))`color: rgba(0, 0, 0, 0.65);

&:hover {
    color: rgba(0, 0, 0, 0.65);
  }

`;